import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "play-arrow",
  "use": "play-arrow-usage",
  "viewBox": "0 0 768 768",
  "content": "<symbol viewBox=\"0 0 768 768\" id=\"play-arrow\"><path d=\"M256.5 160.5l351 223.5-351 223.5v-447z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/play-arrow.svg
// module id = pDbV
// module chunks = 1